module.exports = __webpack_public_path__ + "static/Simona_Burnardzhieva_at_Marker.f9acde15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/art-in-neighborhoods/Simona_Burnardzhieva_at_Marker.jpg
// module id = 474
// module chunks = 107818501498521